import type { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type { GetAccountGivingActionsQuery, GetAccountGivingActionsResponse } from './getAccountGivingActions.types'

const ENDPOINT = 'v1/account/giving-actions'

export const getAccountGivingActions: InfiniteQueryFn<
  [string, GetAccountGivingActionsQuery],
  string,
  GetAccountGivingActionsResponse
> = async (
  client,
  [
    _,
    {
      date,
      country,
      query,
      campaignId,
      includeUnpublished,
      status,
      sort,
      pageSize = 25,
      direction = 'DESC',
      cursor: cursorParam
    }
  ],
  cursor
) =>
  (
    await (cursor
      ? client.get<GetAccountGivingActionsResponse>(cursor, {
          withCredentials: true
        })
      : client.get<GetAccountGivingActionsResponse>(ENDPOINT, {
          params: {
            date,
            country: country ?? undefined,
            query: query || undefined,
            campaignId,
            pageSize,
            direction,
            ...(includeUnpublished ? { includeUnpublished } : {}),
            ...(status ? { status } : {}),
            ...(sort ? { sort } : {}),
            ...(cursorParam ? { cursor: cursorParam } : {})
          },
          withCredentials: true
        }))
  ).data
